import FnApi from '@vue/composition-api'
import Vue from 'vue'
Vue.use(FnApi)
